import { ShieldCheck, Search, Gauge } from "lucide-react";

export const EmailBlacklistsTakeaway = () => {
  return (
    <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent rounded-2xl p-6 sm:p-8 border border-primary/20">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center flex-shrink-0">
          <ShieldCheck className="w-6 h-6 text-primary" />
        </div>
        <div>
          <h2 className="font-display text-lg font-semibold text-foreground mb-2">
            The bottom line
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            <strong className="text-foreground">Blacklists are not one thing.</strong> Severity
            depends entirely on who consults the list, so a listing on a list that nobody
            queries changes nothing about your delivery. Judge a listing by measured placement
            impact rather than by the alert itself, and always diagnose the cause, because a
            listing is sometimes the symptom of a deeper list quality or content problem.
          </p>
          <div className="flex flex-wrap gap-3 mt-4">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-success/10 text-success text-sm">
              <Gauge className="w-3.5 h-3.5" />
              Measure impact, not alerts
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-warning/10 text-warning text-sm">
              <Search className="w-3.5 h-3.5" />
              Always diagnose the cause
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};